import "./style.scss";
import HeroImage01 from "assets/images/png/hero-section-img01.png";
import HeroImage02 from "assets/images/png/hero-section-img02.png";
import HeroImage03 from "assets/images/png/hero-section-img03.png";
import HeroImage04 from "assets/images/png/hero-section-img04.png";
import HeroImage05 from "assets/images/png/hero-section-img05.png";
import UserOnboarding from "../UserOnboarding";

function HeroSection() {
  return (
    <div className="hero-section">
      <span className="tag">Trusted worldwide</span>
      <div className="heading-wrapper container">
        <p className="heading">
          Where Meaningful{" "}
          <span className="font-title-xl heading-bold">Matches Begin!</span>
        </p>
        <p className="sub-heading">
          Click4marry.com, by Madhyamam Daily, is a trusted matrimonial platform
          connecting Keralites and Indian expats worldwide.
        </p>
      </div>

      <div className="onboarding-wrapper-container">
        <div className="user-onboarding-wrapper">
          <UserOnboarding />
        </div>
        <div className="hero-image-wrapper">
          <img
            src={HeroImage01}
            alt="hero-image"
            className="hero-img hero-image01"
          />
          <img
            src={HeroImage02}
            alt="hero-image"
            className="hero-img hero-image02"
          />
          <img
            src={HeroImage03}
            alt="hero-image"
            className="hero-img hero-image03"
          />
          <img
            src={HeroImage04}
            alt="hero-image"
            className="hero-img hero-image04"
          />
          <img
            src={HeroImage05}
            alt="hero-image"
            className="hero-img hero-image05"
          />
        </div>
      </div>

      <p className="description-text ">
        Click4marry.com, by Madhyamam Daily under Ideal Publications Trust, is a
        trusted matchmaking platform for the Indian community, especially
        <span className="description-bold"> Keralites</span>. With easy
        registration and a user-friendly interface, it connects thousands of
        authentic profiles
      </p>
    </div>
  );
}

export default HeroSection;
